export default Object.freeze({
    BREAKOUT_ROOM_PREFIX: "rm"
});